import React, { PureComponent } from 'react'

import { PaymentPage } from '../../../components/MfeParcels/PaymentPage'

import ContainerWithTitle from '../../HOC/ContainerWithTitle'

class PaymentOptionsContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <PaymentPage
        handleError={(error) => {
          //   this.props.setIsMfeLoadingFailed(true)
          console.log(error)
        }}
      />
    )
  }
}

const PaymentOptionsWithTitle = ContainerWithTitle(PaymentOptionsContainer, 'Payments (New)')

export default PaymentOptionsWithTitle



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/PaymentOptionsV2.js